import React, { ComponentProps, PropsWithChildren } from 'react'
import _FloatingDropdown from '../_FloatingDropdown'
import DropdownSheetSheet from './DropdownSheetSheet'

type InheritedSheetProps = Pick<ComponentProps<typeof DropdownSheetSheet>, 'size' | 'height'>
type InheritedFloatingDropdownProps = Pick<ComponentProps<typeof _FloatingDropdown>, 'placement' | 'anchorRef' | 'boundaryRef' | 'triggerRef' | 'open' | 'portaled' | 'onClose' | 'id' | 'data-testid' | 'crossAxisShift' | 'autoHeight'>

interface Props extends PropsWithChildren, InheritedSheetProps, InheritedFloatingDropdownProps {
  ref?: React.Ref<HTMLDivElement>
}

function DropdownSheetBase(props: Props) {
  const {
    children,
    size,
    height,
    placement,
    open,
    anchorRef,
    boundaryRef,
    triggerRef,
    'data-testid': dataTestId,
    id,
    onClose,
    crossAxisShift,
    autoHeight,
    portaled,
    ref,
  } = props

  return <_FloatingDropdown
    ref={ref}
    width={size === 'fill-anchor' ? 'match-anchor' : 'auto'}
    placement={placement}
    anchorRef={anchorRef}
    boundaryRef={boundaryRef}
    triggerRef={triggerRef}
    open={open}
    disableFlip
    data-testid={dataTestId}
    id={id}
    onClose={onClose}
    crossAxisShift={crossAxisShift}
    autoHeight={autoHeight}
    portaled={portaled}
  >
    <DropdownSheetSheet size={size} height={height} autoHeight={autoHeight}>
      {children}
    </DropdownSheetSheet>
  </_FloatingDropdown>
}

export default DropdownSheetBase
